import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { saveUserProfileUrl } from "Constant/api";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { Validator } from "Utils/validator";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";

export const AboutMeModal = ({ show, aboutMeData, toggle, fetchData }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    aboutMe: "",
  });
  const [errMsg, setErrMsg] = useState({
    aboutMe: "",
  });

  const { aboutMe } = formData;

  useEffect(() => {
    if (aboutMeData) {
      setFormData((prev) => ({
        ...prev,
        aboutMe: aboutMeData,
      }));
    }
  }, [aboutMeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (!Validator.text(value)) {
      setErrMsg((prev) => ({
        ...prev,
        [name]: t("common.messages.error.viewProfile.aboutMe.blank"),
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      let isValid = true;
      const errors = {};

      if (!Validator.text(aboutMe)) {
        errors.aboutMe = t("common.messages.error.viewProfile.aboutMe.blank");
        isValid = false;
      }

      setErrMsg((prev) => ({
        ...prev,
        ...errors,
      }));

      resolve(isValid);
    });
  };

  const onSaveAboutMe = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          key: VIEW_PROFILE_SECTIONS.aboutMe,
          [VIEW_PROFILE_SECTIONS.aboutMe]: aboutMe,
        };

        setLoading(true);
        const response = await newAuthService(
          saveUserProfileUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.profileUpdated")
          );
          fetchData();
          toggle();
        } else {
          toast.error(response.message);
        }
      } catch {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={toggle} className="highlightsModal">
      <Modal.Header closeButton>
        <Modal.Title className="text-md font-medium">
          {t("auth.viewProfile.editAboutMe")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <textarea
                className="form-control"
                id="aboutMe"
                name="aboutMe"
                placeholder={t("common.placeHolder.aboutMe")}
                value={aboutMe}
                onChange={handleChange}
                rows={8}
              />
              {errMsg.aboutMe && <p className="error">{errMsg.aboutMe}</p>}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {loading ? (
          <ButtonLoader />
        ) : (
          <Button variant="primary" onClick={onSaveAboutMe}>
            {t("common.button.save")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
